module.exports = __webpack_public_path__ + "img/diy-WzXnKeFu.17e685ca.svg";